var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('main-layout',{attrs:{"margin-top":"14px","wide":""}},[(_vm.isIntegrated)?_c('integrated'):_c('non-integrated')],1)}
var staticRenderFns = []

export { render, staticRenderFns }